import { useCallback } from 'react';
import { prop } from 'ramda';

import { checkUsernameAvailability } from 'js/app/hooks/user/server';
import { useAppSelector } from 'js/store/hooks';

export const useCheckUserNameAvailability = () => {
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async (email, token) => checkUsernameAvailability({ email, token, casinoName }), [casinoName]);
};
